import dayjs from "dayjs"

const FREQUENCY_OFFSETS = {
  DAILY:         [1,  "day"],
  WEEKLY:        [1,  "week"],
  MONTHLY:       [1,  "month"],
  QUARTERLY:     [3,  "month"],
  SEMI_ANNUALLY: [6,  "month"],
  ANNUALLY:      [1,  "year"],
}

const getNextDate = (startDate, frequency) => {
  if (!startDate || !frequency) return undefined
  const [amount, unit] = FREQUENCY_OFFSETS[frequency]
  return dayjs(startDate).add(amount, unit).format("MM/DD/YYYY")
}

export default getNextDate
